import { schemaCommon } from "common/bit/form/FormikSchema"
import * as yup from "yup"

export const schema = yup
  .object({
    licenseNumber: schemaCommon.licenseNumber,
  })
  .defined()

export const initialFormState: yup.InferType<typeof schema> = {
  licenseNumber: "",
}
